import { createAsyncThunk } from '@reduxjs/toolkit';
import { getPromotionalCodes, PromotionalCodeQueryOptions } from '../../api/promoCodes';
import { IPromotionalCode } from 'src/pages/types';

export const fetchPromoCodes = createAsyncThunk<IPromotionalCode[], PromotionalCodeQueryOptions>(
  'promoCodes/fetchPromoCodes',
  async (options, thunkApi) => {
    try {
      const data = await getPromotionalCodes(options);
      return thunkApi.fulfillWithValue(data);
    } catch (error) {
      return thunkApi.rejectWithValue(error);
    }
  }
);
